<template>
  <multipane class="custom-resizer">
    <NavigationList class="listWrapper"  :style="style"/>
    <multipane-resizer></multipane-resizer>
    <div class="content">
      <transition name="slide" mode="out-in">
        <router-view :key="$route.fullPath"/>
      </transition>
    </div>
  </multipane>
</template>

<script>
import NavigationList from '@/components/Navigation/NavigationList'
import { Multipane, MultipaneResizer } from 'vue-multipane'
import { getListWidthWatch, getListWidthCreated } from '@/helpers/listWidth'

export default {
  data () {
    return {
      style: {
        width: '100%'
      }
    }
  },
  components: {
    NavigationList,
    Multipane,
    MultipaneResizer
  },
  watch: {
    '$route' (to, from) {
      getListWidthWatch(to, this.style)
    }
  },
  created () {
    getListWidthCreated(this.$route.params, this.style)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/navigation/Index.vue